import { oz } from '@vy/utils';
import { ProductErpFormInputSchema } from './product-erp-form-input-schema';
import { ProductClassFormInputSchema } from './product-class-form-input-schema';

export const ProductErpFormSchema = oz.object({
  product: ProductErpFormInputSchema.array().default([]),
  classMetadata: ProductClassFormInputSchema.nullish().default(null),
});

export type ProductErpForm = oz.infer<typeof ProductErpFormSchema>;
